
(() => {
  if (window.byidilProgressInitialized) return;
  window.byidilProgressInitialized = true;

  const money = cents =>
    new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);

  let timer;
  let requestId = 0;

  function updateProgress(cart) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());

    const getPart = type =>
      parts.find(part => part.type === type)?.value;

    const berlinDate =
      `${getPart('year')}-${getPart('month')}-${getPart('day')}`;

    const showGiveaway =
      berlinDate >= '2026-10-28' &&
      berlinDate <= '2026-11-05';

    const total = cart.total_price;
    const currency = cart.currency || 'EUR';
    const isEuro = currency === 'EUR';

    const giveawayThreshold = 8000;

    document.querySelectorAll('[data-byidil-progress]').forEach(el => {
      const country = el.dataset.country || 'DE';
      const shippingThreshold = country === 'DE' ? 5000 : 15000;

      const giveaway = el.querySelector('[data-byidil-giveaway]');
      const giveawayMessage = el.querySelector('[data-byidil-giveaway-message]');
      const giveawayBar = el.querySelector('[data-byidil-giveaway-bar]');
      const shippingMessage = el.querySelector('[data-byidil-shipping-message]');
      const shippingBar = el.querySelector('[data-byidil-shipping-bar]');

      if (giveaway) giveaway.hidden = !showGiveaway;

      if (showGiveaway && giveawayMessage && giveawayBar) {
        if (!isEuro) {
          giveawayMessage.textContent =
            'Giveaway entry requires an order of at least €80 (equivalent in your local currency) placed Nov 1–5.';
          giveawayBar.style.width = '0%';
        } else {
          const remaining = Math.max(0, giveawayThreshold - total);

          giveawayMessage.textContent = remaining > 0
            ? `Add ${money(remaining)} more to qualify for our giveaway. Good luck!`
            : berlinDate < '2026-11-01'
              ? 'Minimum reached! Giveaway starts Nov 1.'
              : 'Minimum reached! Complete your order to enter. Good luck!';

          giveawayBar.style.width =
            Math.min(100, total / giveawayThreshold * 100) + '%';
        }
      }

      if (shippingMessage && shippingBar) {
        if (!isEuro) {
          shippingMessage.textContent =
            `Free shipping on orders of €${country === 'DE' ? '50' : '150'} or more (equivalent in your local currency).`;
          shippingBar.style.width = '0%';
        } else {
          const remaining = Math.max(0, shippingThreshold - total);

          shippingMessage.textContent = remaining > 0
            ? `Add ${money(remaining)} more for free shipping${country === 'DE' ? ' within Germany' : ' worldwide'}.`
            : 'You have unlocked free shipping!';

          shippingBar.style.width =
            Math.min(100, total / shippingThreshold * 100) + '%';
        }
      }
    });

    document.querySelectorAll('[data-byidil-reminder]').forEach(el => {
      const giveawayText = el.querySelector('[data-byidil-reminder-giveaway]');
      const shippingText = el.querySelector('[data-byidil-reminder-shipping]');
      const giveawayLine = giveawayText?.closest('.byidil-reminder-line');

      const country =
        document.querySelector('[data-byidil-progress]')?.dataset.country || 'DE';

      const shippingThreshold = country === 'DE' ? 5000 : 15000;

      if (giveawayLine) giveawayLine.hidden = !showGiveaway;

      if (!isEuro) {
        if (giveawayText) giveawayText.textContent = 'Minimum €80 equivalent';
        if (shippingText) {
          shippingText.textContent =
            `Minimum €${country === 'DE' ? '50' : '150'} equivalent`;
        }
      } else {
        if (giveawayText && showGiveaway) {
          giveawayText.textContent = total >= giveawayThreshold
            ? berlinDate < '2026-11-01'
              ? 'Minimum reached · Starts Nov 1'
              : 'Minimum reached · Good luck!'
            : `${money(giveawayThreshold - total)} remaining`;
        }

        if (shippingText) {
          shippingText.textContent = total >= shippingThreshold
            ? 'Free shipping unlocked'
            : `${money(shippingThreshold - total)} remaining`;
        }
      }
    });
  }

  async function refreshProgress() {
    const id = ++requestId;

    try {
      const response = await fetch(
        (window.Shopify?.routes?.root || '/') + 'cart.js',
        { cache: 'no-store' }
      );

      if (!response.ok) return;

      const cart = await response.json();
      if (id !== requestId) return;

      updateProgress(cart);
    } catch (error) {
      console.warn('BYIDIL progress:', error);
    }
  }

  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refreshProgress, 300);
  }

  function init() {
    refreshProgress();

    const drawer = document.querySelector('cart-drawer');

    if (drawer) {
      const observer = new MutationObserver(mutations => {
        const relevant = mutations.some(mutation =>
          Array.from(mutation.addedNodes).some(node =>
            node.nodeType === 1 &&
            (
              node.matches?.('[data-byidil-progress], #CartDrawer-CartItems') ||
              node.querySelector?.('[data-byidil-progress], #CartDrawer-CartItems')
            )
          )
        );

        if (relevant) scheduleRefresh();
      });

      observer.observe(drawer, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('change', event => {
      if (event.target.closest('cart-drawer')) {
        scheduleRefresh();
        setTimeout(refreshProgress, 800);
      }
    });

    document.addEventListener('click', event => {
      if (event.target.closest('cart-drawer quantity-input, cart-drawer cart-remove-button')) {
        setTimeout(refreshProgress, 800);
      }
    });

    document.addEventListener('cart:updated', scheduleRefresh);

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
